var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.292 1.33398H5.70536C3.2787 1.33398 1.83203 2.78065 1.83203 5.20732V10.7873C1.83203 13.2207 3.2787 14.6673 5.70536 14.6673H11.2854C13.712 14.6673 15.1587 13.2207 15.1587 10.794V5.20732C15.1654 2.78065 13.7187 1.33398 11.292 1.33398ZM11.1654 8.50065H8.9987V10.6673C8.9987 10.9407 8.77203 11.1673 8.4987 11.1673C8.22536 11.1673 7.9987 10.9407 7.9987 10.6673V8.50065H5.83203C5.5587 8.50065 5.33203 8.27398 5.33203 8.00065C5.33203 7.72732 5.5587 7.50065 5.83203 7.50065H7.9987V5.33398C7.9987 5.06065 8.22536 4.83398 8.4987 4.83398C8.77203 4.83398 8.9987 5.06065 8.9987 5.33398V7.50065H11.1654C11.4387 7.50065 11.6654 7.72732 11.6654 8.00065C11.6654 8.27398 11.4387 8.50065 11.1654 8.50065Z",
    fill: "#E8E6EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusLight);
export default __webpack_public_path__ + "static/media/plus-light.535cb04efc6db234435b074aba299f76.svg";
export { ForwardRef as ReactComponent };